import React from 'react';
import PropTypes from 'prop-types';
import { Layer, Rect } from '../../../../react-konva';

const MarqueeSelectionOverlay = ({ marqueeRect }) => {
  if (!marqueeRect) {
    return null;
  }

  return (
    <Layer listening={false} name="respark_marquee-selection-layer">
      <Rect
        name="respark_marquee-selection-rect"
        x={marqueeRect.x}
        y={marqueeRect.y}
        width={marqueeRect.width}
        height={marqueeRect.height}
        fill="rgba(59, 130, 246, 0.12)"
        stroke="#3B82F6"
        strokeWidth={1}
        dash={[4, 4]}
      />
    </Layer>
  );
};

MarqueeSelectionOverlay.propTypes = {
  marqueeRect: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
};

MarqueeSelectionOverlay.defaultProps = {
  marqueeRect: null,
};

export default MarqueeSelectionOverlay;
